import { Header } from '@usitsdasdesign/dds-react';
import { useRouter } from 'hooks/navigation-router-with-loading';
import Toast from 'molecules/Toast';
import { useSession } from 'next-auth/react';
import { usePathname } from "next/navigation";
import AvailableAndSchedule from 'organisms/AvailableAndSchedule';
import LayoutMainContainer from 'organisms/LayoutMainContainer';
import SwitchProfile from 'organisms/SwitchProfile';
import PropTypes from 'prop-types';
import {
    useMemo, useRef, useState
} from 'react';
import { createEmployeeAvailabiltyNotification } from 'services/notifications.service';
import useGlobalToastStore from 'store/globalToastStore';
import Delegates from '../Delegates';
import ResourceHeaderArguments from '../Helper/ResourceHeaderArguments';
import Notifications from '../Notifications';
import useClickOutside from '../useClickOutSide';

const addNotification = async ({ title, description, sourceType }) => {
    const res = await createEmployeeAvailabiltyNotification({ title, description, sourceType });
    if (res.status) {
        return res.entity;
    }
    return res.error.response.data.message;
};

const ResourceLayout = ({ children }) => {
    const router = useRouter();
    const pathname = usePathname();
    const [showNotifications, setShowNotifications] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '' });
    const { data: session } = useSession();
    const [isresignInfo, setIsContentVisible] = useState(false);
    const ref = useRef();
    const [showDialog, setShowDialog] = useState('');
    const { isDelegate } = session ?? {};
    useClickOutside(ref, () => setIsContentVisible(false));
    const { setToastData } = useGlobalToastStore();

    const onNotificationClick = () => setShowNotifications(!showNotifications);

    const switchProfile = () => {
        setIsContentVisible(!isresignInfo);
    };

    // const { notifications, fetchNotifications } = useNotificationStore((state) => ({
    //     notifications: state.notifications,
    //     fetchNotifications: state.fetchNotifications
    // }));
    // const [notificationData, setNotificationData] = useState([]);

    const onNoteSend = async (value) => {
        console.log('value', value);
        const data = await addNotification({ title: 'Available', description: value, sourceType: 'employeeAvailability' });
        if (Array.isArray(data)) {
            setToast({ show: true, message: 'Your availability status is shared' });
        } else {
            setToast({ show: true, message: data, variant: 'error' });
        }
    };

    // useEffect(() => {
    //     setNotificationData(notifications?.rows?.map(notification => ({
    //         profileImage: '',
    //         userName: notification?.user?.resource?.name,
    //         time: moment(notification?.createdAt).format("DD-MM-YYYY HH:mm"),
    //         message: getNotificationMessage(notification?.notificationDetail?.description, notification?.notificationData)
    //     })))
    // }, [notifications])

    // useEffect(() => {
    //     let polling = setInterval(() => {
    //         if (session) fetchNotifications()
    //     }, 60000)
    //     return () => {
    //         clearInterval(polling);
    //     }
    // }, []);
    const isNoRoleAssigned = session?.user?.role?.length === 0;
    const isAdminOrRM = ['admin', 'super_admin', 'resource_manager', 'resource_manager_lead', 'guest_rm', 'talent_advisor', 'business_team', 'tpcr_rm', 'tpcr_rm_lead'].some((role) => session?.user?.role?.includes(role));
    const isManagerPartner = session?.user?.gradeLevel === 'manager' || session?.user?.gradeLevel === 'partner';
    const isSubCon = session?.user?.employmentType === 'TPCR' && isNoRoleAssigned;

    const isPodLead = session?.user?.role?.includes('pod_lead');
    const isSLLead = session?.user?.role?.includes('service_line_lead');
    const isSCLead = session?.user?.role?.includes('service_category_lead');
    const isResource = session?.user?.gradeLevel === 'resource' && !isAdminOrRM;
    const isInTakeCoordinator = session?.user?.role?.includes('intake_coordinator');
    const args = useMemo(() => ResourceHeaderArguments(router, pathname, session, onNotificationClick, setShowDialog, setToastData), [
        pathname,
        session
    ]);
    const canViewSwitchProfile = !isSubCon 
                    && (
                        (isDelegate && session?.delegateType === 'all')
                        || (!isDelegate && (isAdminOrRM || isManagerPartner))
                        || (isResource && (isPodLead || isSLLead || isSCLead))
                        || (isInTakeCoordinator)
                    );
    if (!session) { return <></>; }

    return (
        <div className="min-h-screen pt-12">
            <div className="fixed top-0 left-0 w-full z-[997]">
                <Header {...args} />
                <AvailableAndSchedule
                    onNoteSend={onNoteSend}
                    onSchedule={() => false}
                    className='absolute top-0 right-[5.75rem] sm:right-[9rem] h-full w-fit justify-end'
                />
            </div>
            {
                !session?.isDelegate && showDialog === 'Delegates' && (
                    <Delegates
                        onClose={() => setShowDialog('')}
                    />
                )
            }

            {canViewSwitchProfile && (
                <SwitchProfile
                    session={session}
                    onClose={() => setShowEdit('')}
                    active="resource"
                />
            )}
            {showNotifications && <Notifications
                setDrawer={setShowDialog}
                show={showNotifications}
                onClose={() => setShowNotifications(false)} />}
            <LayoutMainContainer children={children} />
            {toast.show && <Toast show={true} message={toast.message} variant={toast.variant} onClose={() => setToast({ show: false })} />}
        </div>
    );
};

ResourceLayout.propTypes = {
    children: PropTypes.node
};
export default ResourceLayout;
